import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const BJRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnBisattningsjournal,
  rutinInfos.rtnWebBisattningsAktAvlidna,
  rutinInfos.rtnWebBisattningsjournal,
];

export default BJRutinMeny;
